import type { UserWithOrganizationsRow } from '~/composables/useUser';

interface UserPrivateState {
  user: UserWithOrganizationsRow | null;
  currentOrg: UserWithOrganizationsRow['organization'][number] | null;
}

const useUserPrivateStore = defineStore('userPrivate', {
  state: (): UserPrivateState => ({
    user: null,
    currentOrg: null,
  }),
});

// TODO this could be a good candidate for a realtime data sync

export const useUserStore = defineStore('user', () => {
  const userPrivateStore = useUserPrivateStore();
  const isStale = ref(true);

  /**
   *
   */
  const setCurrentOrg = (orgId?: string) => {
    if (Array.isArray(userPrivateStore.user?.organization) && userPrivateStore.user.organization.length > 0) {
      if (orgId) {
        userPrivateStore.currentOrg = userPrivateStore.user.organization.find(i => i.organization_id === orgId) ?? null;
      } else {
        userPrivateStore.currentOrg = userPrivateStore.user.organization.at(0) ?? null;
      }
    }
  };

  /**
   *
   */
  const setUser = async (user: UserWithOrganizationsRow) => {
    userPrivateStore.user = user;
    setCurrentOrg();
  };

  /**
   * Clear user state on logout
   */
  const clearUser = () => {
    userPrivateStore.user = null;
    userPrivateStore.currentOrg = null;
    isStale.value = true;
  };

  return {
    // State
    isStale,
    user: computed(() => userPrivateStore.user),
    currentOrg: computed(() => userPrivateStore.currentOrg),
    isMissingOrgs: computed(() => userPrivateStore.user && !userPrivateStore.currentOrg),

    // Actions
    setCurrentOrg,
    setUser,
    clearUser,
  };
});
